import { techSupportAccess } from '@/utils/techSupportAccess'

const roles = ['general_manager', 'support']

export default {
  path: '/tech-support',
  component: () => import('@/views/tech-support/Index'),
  redirect: { name: 'tech-support-releases' },
  children: [
    ...['message-operations', 'integration-logs'].map(workspace => ({
      path: workspace,
      component: () => import('@/views/tech-support/Index'),
      redirect: { name: `tech-support-${workspace}-telegram` },
      meta: { title: workspace === 'message-operations' ? 'Message Operations' : 'Integration Logs', roles },
      children: ['telegram', 'whatsapp', 'email', 'sendpulse', 'knowledge_ai'].map(integration => ({
        path: integration,
        name: `tech-support-${workspace}-${integration}`,
        component: () => import('@/views/tech-support/integrations/Workspace'),
        props: { workspace, integration },
        meta: {
          title: `${{ telegram: 'Telegram', whatsapp: 'WhatsApp', email: 'Email', sendpulse: 'SendPulse', knowledge_ai: 'Knowledge AI' }[integration]} ${workspace === 'message-operations' ? 'Operations' : 'Integration Logs'}`,
          roles,
          access: techSupportAccess(workspace === 'message-operations' ? 'message_operations' : 'integration_logs')
        }
      }))
    })),
    {
      path: 'tickets',
      component: () => import('@/views/tech-support/tickets/SupportLayout'),
      redirect: { name: 'support-ticket-dashboard' },
      children: [
        {
          path: 'dashboard',
          name: 'support-ticket-dashboard',
          component: () => import('@/views/tech-support/tickets/Dashboard'),
          meta: { title: 'Support dashboard', roles, access: techSupportAccess('support') }
        },
        {
          path: 'list',
          redirect: { name: 'support-ticket-tasks' },
          meta: { title: 'Support tasks', roles, access: techSupportAccess('support') }
        },
        {
          path: 'tasks',
          name: 'support-ticket-tasks',
          component: () => import('@/views/tech-support/tickets/TicketList'),
          meta: { title: 'Support tasks', roles, access: techSupportAccess('support') }
        },
        {
          path: 'tracker',
          name: 'support-ticket-tracker',
          component: () => import('@/views/tech-support/tickets/Tasks'),
          meta: { title: 'Support task tracker', roles, access: techSupportAccess('support') }
        },
        {
          path: 'archive',
          name: 'support-ticket-archive',
          component: () => import('@/views/tech-support/tickets/Archive'),
          meta: { title: 'Support archive', roles, access: techSupportAccess('support') }
        },
        {
          path: 'manage',
          name: 'support-ticket-manage',
          component: () => import('@/views/tech-support/tickets/Manage'),
          meta: { title: 'Manage support fields', roles, access: techSupportAccess('support') }
        }
      ]
    },
    {
      path: 'my-tickets',
      name: 'support-ticket-my-tickets',
      component: () => import('@/views/tech-support/tickets/MyTickets'),
      meta: { title: 'My support tickets', roles: [] }
    },
    {
      path: 'insurance-updates',
      redirect: to => ({ name: 'ground-ops-insurance-updates', query: to.query, hash: to.hash }),
      meta: { title: 'Insurance updates', roles }
    },
    {
      path: 'trengo/:resource?',
      name: 'tech-support-trengo',
      component: () => import('@/views/tech-support/trengo/Index'),
      meta: {
        title: 'Trengo',
        roles,
        access: techSupportAccess('trengo')
      }
    },
    {
      path: 'mailgun/templates',
      name: 'tech-support-mailgun-templates',
      component: () => import('@/views/tech-support/mailgun/Index'),
      meta: { title: 'Mailgun templates', roles, access: techSupportAccess('mailgun') }
    },
    {
      path: 'ai-analysis',
      name: 'tech-support-ai-analysis',
      component: () => import('@/views/tech-support/ai-analysis/Index'),
      meta: { title: 'AI analysis', roles, access: techSupportAccess('trengo') }
    },
    {
      path: 'releases',
      name: 'tech-support-releases',
      component: () => import('@/views/tech-support/releases/List'),
      meta: {
        title: 'Releases',
        roles,
        access: techSupportAccess('releases')
      }
    },
    {
      path: 'observability',
      name: 'tech-support-observability',
      component: () => import('@/views/tech-support/observability/Dashboard'),
      meta: {
        title: 'Observability',
        roles,
        access: techSupportAccess('observability')
      }
    },
    {
      path: 'flight-tickets',
      component: () => import('@/views/tech-support/flight-tickets/Layout'),
      children: [
        {
          path: '',
          name: 'tech-support-flight-tickets-relevant',
          component: () => import('@/views/tech-support/flight-tickets/RelevantTickets'),
          meta: {
            title: 'AI Flight Tickets',
            roles,
            access: techSupportAccess('flight_tickets')
          }
        },
        {
          path: 'issues',
          name: 'tech-support-flight-tickets-issues',
          component: () => import('@/views/tech-support/flight-tickets/Issues'),
          meta: {
            title: 'AI Flight Tickets issues',
            roles,
            access: techSupportAccess('flight_tickets')
          }
        }
      ]
    }
  ]
}
